<template>
  <div class="ActivityWorkflow">
    <v-data-table
      class="ActivityWorkflow__data-table elevation-0"
      :items="rows"
      :headers="headers"
      single-expand
      item-key="id"
      :loading="loading"
      @update:page="(val) => updateQuery(val, 'page')"
      @update:items-per-page="(val) => updateQuery(val, 'limit')"
      :server-items-length="activityTotalNumber"
    >
      <template #item.trigger="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-chip
              small
              class="d-flex align-center"
              v-bind="attrs"
              v-on="on"
              outlined
            >
              <v-icon left small class="mr-1">mdi-calendar-clock</v-icon>
              {{ cronTime(item) }}
            </v-chip>
          </template>
          <span> <strong>Cron:</strong> {{ item.trigger }} </span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import * as moment from 'moment-timezone';
import { createNamespacedHelpers } from 'vuex';
import cronstrue from 'cronstrue';

const {
  mapGetters: activityGetters,
  mapActions: activityActions,
  mapMutations: activityMutations,
} = createNamespacedHelpers('activity');
const { mapGetters: customerGetters } = createNamespacedHelpers('customer');

const defaultHeaders = {
  sortable: false,
  align: 'start',
};
export default {
  name: 'UpcomingWorkflow',
  computed: {
    ...customerGetters({
      customers: 'CUSTOMERS',
    }),
    ...activityGetters({
      activityTotalNumber: 'GET_ACTIVITY_TOTAL_NUMBER',
      activityPage: 'GET_ACTIVITY_PAGE',
      activityLimit: 'GET_ACTIVITY_LIMIT',
    }),
  },
  props: {
    queryData: {
      search: '',
      dayOfWeek: null,
    },
    rows: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    reportType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Workflow name',
          value: 'name',
          ...defaultHeaders,
        },
        { text: 'Schedule', value: 'trigger', ...defaultHeaders },
        { text: 'Is AI Workflow', value: 'aiWorkflow', ...defaultHeaders },
        { text: 'Enabled', value: 'enabled', ...defaultHeaders },
        { text: 'Is Serverless', value: 'isServerless', ...defaultHeaders },
      ],
    };
  },
  methods: {
    ...activityActions(['getActivity']),
    ...activityMutations({
      setActivityPage: 'SET_ACTIVITY_PAGE',
      setActivityLimit: 'SET_ACTIVITY_LIMIT',
    }),
    formatDate(date) {
      if (!date) return '';
      else return moment(date).tz('UTC').format('YYYY-MM-DD HH:mm');
    },
    updateQuery(val, type) {
      if (type === 'page') {
        this.setActivityPage(val);
      }

      if (type === 'limit') {
        this.setActivityLimit(val);
      }

      this.getActivity({
        report_type: this.reportType,
        page: (this.activityPage || 1) - 1,
        limit: this.activityLimit,
        search: this.queryData.search,
        dayOfWeek: this.queryData.dayOfWeek
          ? new Date(this.queryData.dayOfWeek).getDay()
          : null,
      });
    },
    cronTime(workflow) {
      try {
        return cronstrue.toString(workflow.trigger);
      } catch (e) {
        return workflow.trigger;
      }
    },
  },
  mounted() {
    this.limit = 10;
  },
  created() {
    this.limit = 10;
  },
};
</script>
